export default "__VITE_ASSET__C8NqC7H9__"